import { render } from "./DropdownContent.vue?vue&type=template&id=35b91e64&scoped=true&ts=true"
import script from "./DropdownContent.vue?vue&type=script&lang=ts"
export * from "./DropdownContent.vue?vue&type=script&lang=ts"

import "./DropdownContent.vue?vue&type=style&index=0&id=35b91e64&scoped=true&lang=css"

import exportComponent from "/builds/arkindex/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35b91e64"]])

export default __exports__